<template>
  <div class="row">
    <div class="col-md-8 offset-md-2 bg-light">
      <div v-if="enableFacebookLogin || enableGoogleLogin" class="row pt-4">
        <div class="col-md-8 offset-md-2 px-3">
          <facebook-sign-in v-if="enableFacebookLogin" :login-url="facebookLoginUrl" class="mb-3" />
          <google-sign-in v-if="enableGoogleLogin" :login-url="googleLoginUrl" class="mb-3" />
        </div>
      </div>

      <sign-up-form v-bind="formProps" class="px-3 px-md-4 mt-5" @authenticated="authenticated"
                    @awaitingEmailConfirmation="showAwaitingConfirmationModal" @mfa-setup-required="mfaSetupRequired"
                    @errorOnSignUp="showNonRecoverableError" />

      <confirm-your-email-modal v-if="awaitingEmailConfirmation" :email-address="confirmationEmailSentTo"
                                :email-sent-message="i18n.t('member.account.confirm_your_email_modal.sent_for_user')" />
      <generic-error-modal v-if="nonRecoverableError" :error-message="nonRecoverableError" />
    </div>
  </div>
</template>

<script>
import ConfirmYourEmailModal from '../components/confirm-your-email-modal'
import FacebookSignIn from './facebook-sign-in'
import GenericErrorModal from '../components/generic-error-modal.vue'
import GoogleSignIn from './google-sign-in'
import SignUpForm from './sign-up-form'

const DEFAULT_SIGN_UP_PATH = '/users'

export default {
  components: { ConfirmYourEmailModal, GenericErrorModal, FacebookSignIn, GoogleSignIn, SignUpForm },

  props: {
    additionalFieldConfigs: {
      type: Array,
      required: true
    },

    askForCountry: {
      type: Boolean,
      required: true
    },

    askForPostcode: {
      type: Boolean,
      required: true
    },

    askForSmsOptIn: {
      type: Boolean,
      required: true
    },

    countryData: {
      type: Object,
      requireds: false
    },

    emailOptInTypeData: {
      type: Object,
      required: true
    },

    emailOptInLabel: {
      type: String,
      required: true
    },

    enableFacebookLogin: {
      type: Boolean,
      required: false,
      default: false
    },

    enableGoogleLogin: {
      type: Boolean,
      required: false,
      default: false
    },

    euDataProcessingConsentData: {
      type: Object,
      required: false
    },

    facebookLoginUrl: {
      type: String,
      required: false
    },

    googleLoginUrl: {
      type: String,
      required: false
    },

    invitation: {
      type: Object,
      required: false
    },

    newAccountDisclaimer: {
      type: String,
      required: false
    },

    phoneNumberLabel: {
      type: String,
      required: true
    },

    phoneNumberMandatory: {
      type: Boolean,
      required: true
    },

    postcodeLabel: {
      type: String,
      required: false
    },

    showEuDataProcessingConsent: {
      type: Boolean,
      required: true
    },

    smsOptInLabel: {
      type: String,
      required: false
    },

    smsOptInTypeData: {
      type: Object,
      required: false
    },

    termsOfServiceData: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      awaitingEmailConfirmation: false,
      confirmationEmailSentTo: null,
      nonRecoverableError: null
    }
  },

  computed: {
    formProps() {
      const componentProps = {
        acceptTermsOfServiceLabel: this.termsOfServiceData.label,
        additionalFieldConfigs: this.additionalFieldConfigs,
        askForCountry: this.askForCountry,
        askForPostcode: this.askForPostcode,
        askForSmsOptIn: this.askForSmsOptIn,
        emailOptInLabel: this.emailOptInLabel,
        emailOptInTypeData: this.emailOptInTypeData,
        euDataProcessingConsentData: this.euDataProcessingConsentData,
        includeEuDataProcessingConsent: this.showEuDataProcessingConsent,
        invitation: this.invitation,
        newAccountDisclaimer: this.newAccountDisclaimer,
        phoneNumberLabel: this.phoneNumberLabel,
        phoneNumberMandatory: this.phoneNumberMandatory,
        signUpPath: DEFAULT_SIGN_UP_PATH,
        smsOptInLabel: this.smsOptInLabel,
        smsOptInTypeData: this.smsOptInTypeData,
        submitButtonText: this.i18n.t('member.account.authentication_modal.sign_up_submit'),
        termsOfServiceExplicit: this.termsOfServiceData.displayExplicitCheckbox
      }

      if (this.askForPostcode) {
        componentProps['postcodeLabel'] = this.postcodeLabel
      }

      if (this.countryData) {
        componentProps['countryLabel'] = this.countryData.label
        componentProps['countryOptions'] = this.countryData.countryOptions
        componentProps['countryTogglesEuDataProcessingConsent'] = this.countryData.countryTogglesEuDataProcessingConsent
      }

      return componentProps
    }
  },

  methods: {
    authenticated({ afterSignInRedirect }) {
      window.location.href = afterSignInRedirect
    },

    mfaSetupRequired({ enableMfaPath }) {
      window.location.href = enableMfaPath
    },

    showAwaitingConfirmationModal({ userEmail }) {
      this.awaitingEmailConfirmation = true
      this.confirmationEmailSentTo = userEmail
    },

    showNonRecoverableError({ errorMessage }) {
      this.nonRecoverableError = errorMessage
    }
  }
}
</script>
